import { PaymentSetup } from "~/components/onboarding/payment-setup";
import { Spinner } from "~/components/ui/spinner";

export function AddPaymentMethodStep({
  isLoading,
  clientSecret,
  onSuccess,
  onError,
}: {
  isLoading: boolean;
  clientSecret: string | null;
  onSuccess: () => void;
  onError: (error: Error) => void;
}) {
  if (isLoading || !clientSecret) {
    return (
      <div className="mx-auto flex max-w-lg items-center justify-center">
        <div className="bg-background flex items-center justify-center rounded-lg border p-12">
          <Spinner className="size-8" />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto flex max-w-lg items-center justify-center">
      <PaymentSetup
        clientSecret={clientSecret}
        onError={onError}
        onSuccess={onSuccess}
      />
    </div>
  );
}
